import axios from '@/utils/request'
import base from './base'
import qs from 'qs'

export function tradeGroupList(data) {
  return axios.post(`${base.url}/business/tradeGroup/list`, qs.stringify(data))
}

export function tradeGroupDetail(id) {
  return axios.post(`${base.url}/business/tradeGroup/detail`, qs.stringify({ id }))
}

export function tradeGroupAddOrUpdate(data) {
  return axios.post(`${base.url}/business/tradeGroup/addOrUpdate`, JSON.stringify(data), {
    headers: { 'Content-Type': 'application/json' }
  })
}

export function tradeGroupDeleteBatchIds(ids) {
  return axios.post(`${base.url}/business/tradeGroup/deleteBatchIds`, qs.stringify({ ids }))
}

export function tradeGroupStatus(id, status) {
  return axios.post(`${base.url}/business/tradeGroup/status`, qs.stringify({ id, status }))
}

export function tradeGroupSetDefault(id) {
  return axios.post(`${base.url}/business/tradeGroup/setDefault`, qs.stringify({ id }))
}

export function tradeGroupAddCountryConfig(data) {
  return axios.post(`${base.url}/business/tradeGroup/addCountryConfig`, JSON.stringify(data), {
    headers: { 'Content-Type': 'application/json' }
  })
}

export function tradeGroupSyncProductCount(data) {
  return axios.post(`${base.url}/business/tradeGroup/syncProductCount`, qs.stringify(data))
}

export function tradeGroupCreateOne(data) {
  return axios.post(`${base.url}/business/tradeGroup/createOne`, JSON.stringify(data), {
    headers: { 'Content-Type': 'application/json' }
  })
}

export function tradeGroupRetryCreate(data) {
  return axios.post(`${base.url}/business/tradeGroup/retryCreate`, JSON.stringify(data), {
    headers: { 'Content-Type': 'application/json' }
  })
}

export function tradeGroupLogList(data) {
  return axios.post(`${base.url}/business/tradeGroup/log/list`, qs.stringify(data))
}

export function tradeGroupProductList(groupId) {
  return axios.post(`${base.url}/business/tradeGroup/product/list`, qs.stringify({ groupId }))
}

export function tradeGroupProductCandidateList(data) {
  return axios.post(`${base.url}/business/tradeGroup/product/candidateList`, qs.stringify(data))
}

export function tradeGroupProductDetail(id) {
  return axios.post(`${base.url}/business/tradeGroup/product/detail`, qs.stringify({ id }))
}

export function tradeGroupProductAdd(data) {
  return axios.post(`${base.url}/business/tradeGroup/product/add`, JSON.stringify(data), {
    headers: { 'Content-Type': 'application/json' }
  })
}

export function tradeGroupProductRemove(data) {
  return axios.post(`${base.url}/business/tradeGroup/product/remove`, JSON.stringify(data), {
    headers: { 'Content-Type': 'application/json' }
  })
}

export function tradeGroupProductUpdate(data) {
  return axios.post(`${base.url}/business/tradeGroup/product/update`, JSON.stringify(data), {
    headers: { 'Content-Type': 'application/json' }
  })
}
